import { BaseAction } from './base.action';
import { NotificationService } from '../../services';

export class EnableButtonAction extends BaseAction {

    constructor(private notificationService: NotificationService) {
        super();
    }

    act(): void {
        console.warn('Chat button enable / disable functionality has been deprecated. Please remove any related code from chat snippet.');
    }
}
